
export class ErrorResponse extends Error {
  code: number;
  statusText: string;
  public constructor(message: string, code: number, statusText: string) {
    super ("Errore: " + message);
    this.code = code;
    this.statusText = statusText;
  }
}